import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UsersService } from '@app/shared/services/users.service';
import { PhotoService } from '@app/shared/services/photo.service';
declare var UIkit: any;

@Component({
  selector: 'app-edit-user-documents',
  templateUrl: './edit-user-documents.component.html',
  styleUrls: ['./edit-user-documents.component.scss']
})
export class EditUserDocumentsComponent {

  @Input('id') id : number;
  @Output() changed = new EventEmitter();

  public idRecto : any = null;
  public idVerso : any = null;
  public drivingRecto : any = null;
  public drivingVerso : any = null;

  constructor(
    private userService: UsersService,
    private photoService: PhotoService
  ) { }

  modifyPhoto(part) : void {
    this.photoService.askFile().then((photo) => {
      switch (part) {
        case 1:
          this.drivingRecto = photo;
          break;
        case 2:
          this.drivingVerso = photo;
          break;
        case 3:
          this.idRecto = photo;
          break;
        case 4:
          this.idVerso = photo;
          break;
      }
    });
  }

  cancelPhoto(part) : void {
    switch (part) {
      case 1:
        this.drivingRecto = null;
        break;
      case 2:
        this.drivingVerso = null;
        break;
      case 3:
        this.idRecto = null;
        break;
      case 4:
        this.idVerso = null;
        break;
    }
  }

  updateDocuments() : void {
    let promises : Array<any> = [];

    if (this.drivingRecto !== null) {
      promises.push(this.userService.updateDocument(this.id, 1, this.drivingRecto));
    }
    if (this.drivingVerso !== null) {
      promises.push(this.userService.updateDocument(this.id, 2, this.drivingVerso));
    }
    if (this.idRecto !== null) {
      promises.push(this.userService.updateDocument(this.id, 3, this.idRecto));
    }
    if (this.idVerso !== null) {
      promises.push(this.userService.updateDocument(this.id, 4, this.idVerso));
    }
    Promise.all(promises).then(() => {
      this.drivingVerso = null;
      this.drivingRecto = null;
      this.idVerso = null;
      this.idRecto = null;
      this.changed.emit();
      UIkit.modal('#edit-user-documents').hide();
    });
  }

}
